<template>
  <component
    :is="rootTag"
    :href="isClickable ? channelHref : undefined"
    :class="['card', 'p-x2', { pressable: isClickable }]"
  >
    <div class="f f-h f-ac f-sb">
      <div class="f f-h f-ac f-grow">
        <!-- Participation and Sentiment Icons -->
        <div class="f f-v f-gap-8 m-rx2">
          <!-- Participation bars (meters-bars icon) -->
          <cdn-svg
            :path="engagementBarsPath"
            :version="0"
            class="h-x4 w-x4"
          />
          <!-- Sentiment face -->
          <cdn-svg
            :path="sentimentFacePath"
            :version="0"
            class="h-x4 w-x4"
          />
        </div>

        <div class="f-v f-grow">
          <div class="f f-h f-ac">
            <div class="t-lg bold m-rx1">{{ channelPulseReport.channel.name }}</div>
            <div v-if="!channelPulseReport.config.isActive" class="t-sm gray italic">
              (Channel is not active)
            </div>
          </div>
          <div v-if="channelPulseReport.state === 'lost_pulse'" class="t-ml display dark-gray m-tx1">
            {{ channelPulseReport.summary }}
          </div>
          <div v-else-if="channelPulseReport.state === 'never_generated' || channelPulseReport.state === 'generating'" class="t-ml display dark-gray m-tx1">
            {{ channelPulseReport.summary }}
          </div>
          <div v-else-if="channelPulseReport.hasReport && channelPulseReport.summary" class="t-ml display m-tx1">
            {{ channelPulseReport.summary }}
          </div>
          <div v-else class="t-ml display dark-gray m-tx1">
            {{ channelPulseReport.summary || 'No report available for this week.' }}
          </div>
        </div>
      </div>
    </div>
  </component>
</template>

<script setup>
import { computed } from 'vue';
import useEngagementReportIcons from 'composables/team-pulse/icons';

const props = defineProps({
  channelPulseReport: {
    type: Object,
    required: true,
  },
});

// Use composable for engagement report icons
const { engagementBarsPath, sentimentFacePath } = useEngagementReportIcons(
  computed(() => props.channelPulseReport),
);

const isClickable = computed(() => props.channelPulseReport?.config?.enabled === true);
const rootTag = computed(() => (isClickable.value ? 'a' : 'div'));
const channelHref = computed(() => `/team_pulse/channels/${props.channelPulseReport.channel.id}`);
</script>


